import { Method } from './apireftypes';
import { Util } from '../fasades/util';

export class GenCodePython {
    private method: Method;
    private url: string;
    private body?: object;

    constructor(method: Method, url: string, body?: object) 
    {
        this.method = method;
        this.url    = url;
        this.body   = body;
    }

    generateImport(): string {
        const isStreaming = this.body !== undefined && (this.body as any).stream === true;
        
        if (isStreaming) {
            return `import requests
import json
import os
import sys

`;
        } else {
            return `import requests
import json
import os

`;
        }
    }

    generateRequest(): string {
        const isDelete = this.method === Method.Delete;
        const isPost = this.method === Method.Post;
        const methodFunc = isDelete ? 'delete' : isPost ? 'post' : 'get';
        const isStreaming = this.body !== undefined && (this.body as any).stream === true;

        if (this.body !== undefined && !isDelete) {
            const jsonString = JSON.stringify(this.body, null, 2);
            // Convert JSON to Python-compatible format (null -> None, true -> True, false -> False)
            // Python accepts double quotes in dict literals, so we keep them
            const pythonDict = jsonString
                .replace(/null/g, 'None')
                .replace(/true/g, 'True')
                .replace(/false/g, 'False');

            // Indent the dict to match Python style
            const indentedDict = pythonDict.split('\n').map((line, index) => 
                index === 0 ? '    ' + line : '    ' + line
            ).join('\n');

            if (isStreaming) {
                return `request_body = ${indentedDict}

response = requests.${methodFunc}(
    '${Util.getTigerAPIUrl()}${this.url}',
    headers={
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + os.environ['TIGER_API_KEY']
    },
    json=request_body,
    stream=True
)

`;
            } else {
                return `request_body = ${indentedDict}

response = requests.${methodFunc}(
    '${Util.getTigerAPIUrl()}${this.url}',
    headers={
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + os.environ['TIGER_API_KEY']
    },
    json=request_body
)

`;
            }
        } else {
            const headers = isDelete
                ? `    headers={
        'Authorization': 'Bearer ' + os.environ['TIGER_API_KEY']
    }`
                : `    headers={
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + os.environ['TIGER_API_KEY']
    }`;

            return `response = requests.${methodFunc}(
    '${Util.getTigerAPIUrl()}${this.url}',
${headers}
)

`;
        }
    }

    readResponse(): string {
        return `response.raise_for_status()
print(json.dumps(response.json(), indent=2))`;
    }

    readResponseStreaming(): string {
        return `response.raise_for_status()

for line in response.iter_lines():
    if line:
        try:
            chunk = json.loads(line)
            
            if chunk.get('type') == 'info':
                print(f'Info: {chunk["message"]}')
            elif chunk.get('type') == 'delta':
                print(chunk['delta'], end='', flush=True)
            elif chunk.get('type') == 'stop':
                print(f'\\nGeneration complete: {chunk["usage"]}')
            elif chunk.get('type') == 'error':
                print(f'Error: {chunk["message"]}', file=sys.stderr)
                break  # Stop processing on error
        except json.JSONDecodeError as e:
            print(f'Failed to parse chunk: {line}', file=sys.stderr)`;
    }

    readResponseStreamingTraining(): string {
        return `response.raise_for_status()

for line in response.iter_lines():
    if line:
        try:
            chunk = json.loads(line)
            
            if chunk.get('type') == 'info':
                print(f'Info: {chunk["message"]}')
            elif chunk.get('type') == 'performance':
                perf = chunk.get('performance', {})
                print(f'Step {perf.get("step_no", "?")}, Sample {perf.get("id", "?")}: accuracy={perf.get("accuracy", "?")}, advantage={perf.get("advantage", "?")}, loss={perf.get("loss", "?")}')
            elif chunk.get('type') == 'usage':
                usage = chunk.get('usage', {})
                print(f'Training complete: {usage}')
            elif chunk.get('type') == 'error':
                print(f'Error: {chunk["message"]}', file=sys.stderr)
                break  # Stop processing on error
        except json.JSONDecodeError as e:
            print(f'Failed to parse chunk: {line}', file=sys.stderr)`;
    }

}
